import PropTypes from 'prop-types';
import { useState, useEffect, useCallback } from 'react';

import useTranslation from '../hooks/useTranslation';

export function PasswordRequirements({
  password = '',
  setEnabledButton
}) {
  const { t } = useTranslation();
  const [passwordLength, setPasswordLength] = useState(false);
  const [passwordLowerLetter, setPasswordLowerLetter] = useState(false);
  const [passwordUpperLetter, setPasswordUpperLetter] = useState(false);
  const [passwordNumber, setPasswordNumber] = useState(false);
  const [passwordSpecial, setPasswordSpecial] = useState(false);

  const validatePassword = useCallback(() => {
    if (password.length >= 8) {
      setPasswordLength(true);
    } else {
      setPasswordLength(false);
    }

    const patternLowerLetter = /[a-z]/;
    if (patternLowerLetter.test(password)) {
      setPasswordLowerLetter(true);
    } else {
      setPasswordLowerLetter(false);
    }

    const patternUpperLetter = /[A-Z]/;
    if (patternUpperLetter.test(password)) {
      setPasswordUpperLetter(true);
    } else {
      setPasswordUpperLetter(false);
    }

    const patternNumber = /[0-9]/;
    if (patternNumber.test(password)) {
      setPasswordNumber(true);
    } else {
      setPasswordNumber(false);
    }

    const patternSpecial = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>?]/g;
    if (patternSpecial.test(password)) {
      setPasswordSpecial(true);
    } else {
      setPasswordSpecial(false);
    }

    const patternEnabledButton = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>?])([A-Za-z\d!@#$%^&*()_+\-=[\]{};':"\\|,.<>?]|[^ ]){8,15}$/;
    if (patternEnabledButton.test(password)) {
      setEnabledButton(false);
    } else {
      setEnabledButton(true);
    }
  }, [password, setEnabledButton]);

  useEffect(() => {
    validatePassword();
  }, [password.length, validatePassword]);

  return (
    <ul className="list-group list-group-flush mb-1">
      <li className="list-group-item border-0 p-0">
        <small>
          <strong>
            {`${t('Password Requirements')}:`}
          </strong>
        </small>
      </li>
      <li className={`list-group-item border-0 p-0 text-${passwordLength ? 'success' : 'danger'}`}>
        <small>{t('Minimum password length 8 characters')}</small>
      </li>
      <li className={`list-group-item border-0 p-0 text-${passwordNumber ? 'success' : 'danger'}`}>
        <small>{t('Contains at least 1 number')}</small>
      </li>
      <li className={`list-group-item border-0 p-0 text-${passwordSpecial ? 'success' : 'danger'}`}>
        <small>{t('Contains at least 1 special character')}</small>
      </li>
      <li
        className={`list-group-item border-0 p-0 text-${passwordUpperLetter
          ? 'success'
          : 'danger'}`}
      >
        <small>{t('Contains at least one capital letter')}</small>
      </li>
      <li
        className={`list-group-item border-0 p-0 text-${passwordLowerLetter
          ? 'success'
          : 'danger'}`}
      >
        <small>{t('Contains at least one lowercase letter')}</small>
      </li>
    </ul>
  );
}

PasswordRequirements.propTypes = {
  password: PropTypes.string,
  setEnabledButton: PropTypes.func
};

export default PasswordRequirements;
